<template>
  <div :class="styleMain">
    <span>Possession de balle</span>
    <el-slider v-model="value" :min="0" :max="100" :show-input="true" :show-input-controls="false" input-size="mini" :show-tooltip="false" @change="update" />
  </div>
</template>

<script>
import { ucFirst } from '@/helpers/format'

export default {
  name: 'SportFootballMatchTeamStatisticsPossession',
  props: {
    match: Object,
    team: Object
  },
  data () {
    return {
      state: null,
      statePrevious: null
    }
  },
  computed: {
    homeAway () { return this.match?.homeAway(this.team) },
    awayHome () { return this.match?.awayHome(this.team) },
    possession () { return this.match ? this.match['possession' + ucFirst(this.homeAway)] : null },
    value: {
      get () { return this.possession },
      set (value) {
        this.statePrevious = this.state
        this.state = value
      }
    },
    styleMain () { return ['sportFootballMatchTeamStatisticsPossession', this.homeAway] }
  },
  methods: {
    update (value) {
      value = this.state === value ? this.statePrevious : this.state
      const data = { id: this.match.id }
      data['possession' + ucFirst(this.homeAway)] = value
      data['possession' + ucFirst(this.awayHome)] = 100 - value
      this.$store.dispatch('Sport/Football/Match/put', data)
    }
  }
}
</script>

<style>
.sportFootballMatchTeamStatisticsPossession{
  position:relative;
  height:46px;
  margin:0 24px 2px 24px;
  padding:0 16px;
  background-color:var(--color-background-grey);
  border-radius:4px;
  box-sizing: border-box;
  display:flex;
}
.sportFootballMatchTeamStatisticsPossession.away{
  flex-direction:row-reverse;
}
.sportFootballMatchTeamStatisticsPossession > span{
  flex:2;
  font-size:14px;
  font-weight:bold;
  line-height: 14px;
  align-self: center;
  text-align: center;
}
.sportFootballMatchTeamStatisticsPossession > div{
  flex:3;
  height:26px;
  align-self: center;
  padding:0 10px;
}
.sportFootballMatchTeamStatisticsPossession .el-slider__input{
  width:30px;
  padding:0;
  margin-top:0;
}
.sportFootballMatchTeamStatisticsPossession.away .el-slider__input{
  float:left;
}
.sportFootballMatchTeamStatisticsPossession .el-slider__input .el-input__inner{
  padding:0;
  height:26px;
}
.sportFootballMatchTeamStatisticsPossession.home .el-slider__runway{
  margin:9px 45px 10px 0;
}
.sportFootballMatchTeamStatisticsPossession.away .el-slider__runway{
  margin:9px 0 10px 45px;
}
.sportFootballMatchTeamStatisticsPossession .el-slider__button-wrapper{
  top:-10px;
  height:26px;
}
.sportFootballMatchTeamStatisticsPossession .el-slider__button{
  border-color: var(--color-background-grey-dark)
}
.sportFootballMatchTeamStatisticsPossession.home .el-slider__bar{
  background-color: var(--color-team-home)
}
.sportFootballMatchTeamStatisticsPossession.away .el-slider__bar{
  background-color: var(--color-background-grey-dark)
}
.sportFootballMatchTeamStatisticsPossession.home .el-slider__runway{
  background-color: var(--color-background-grey-dark)
}
.sportFootballMatchTeamStatisticsPossession.away .el-slider__runway{
  background-color: var(--color-team-away)
}
.sportFootballMatchTeamStatisticsPossession.home .el-input__inner:hover{
  border-color: var(--color-team-home)
}
.sportFootballMatchTeamStatisticsPossession.away .el-input__inner:hover{
  border-color: var(--color-team-away)
}
</style>
